import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import { useWorkspaceStore } from '../workspaceStore';

import { stateCreator } from './state';

export * from './selector';

export const useUserStore = create(subscribeWithSelector(stateCreator));

// We need this because credits info endpoint highly depends on the workspace to be initialized with the right data
// However, userStore is initialized before workspaceStore, so we need to update the info whenever workspaceStore is ready
useWorkspaceStore.subscribe((state, prevState) => {
  if (state.designWorkspaceId && !prevState.designWorkspaceId) {
    useUserStore.getState().updateUserCreditInfo();
  }
});
